export default "__VITE_PUBLIC_ASSET__033a92de__"